import { Routes, Route } from "react-router-dom";
import App from "@/App";
import HomePage from "@/components/pages/HomePage";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/landing" element={<App />} />
    </Routes>
  );
}

export default AppRouter;
